var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('text-input',{staticClass:"mt-0",attrs:{"setup":{
    'func': _vm.modelSetter,
    'args': {
      'model': this,
      'key': 'threadId',
      'prefix': 'editor_',
    }
  }}},[_c('a-button',{staticClass:"btn-success",attrs:{"slot":"input-button","icon":"check"},on:{"click":_vm.prepareTopicId},slot:"input-button"},[_vm._v(" "+_vm._s(_vm.$t('add'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }